/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates.
 * Licensed under The Universal Permissive License (UPL), Version 1.0
 * as shown at https://oss.oracle.com/licenses/upl/
 * @ignore
 */
import { TimeComponentLayersStack } from '../PRIVATE_TimeComponent';
import { GanttTaskFocusEffectsLayer } from './GanttTaskFocusEffectsLayer';
import { GanttTaskHoverEffectsLayer } from './GanttTaskHoverEffectsLayer';
import { GanttTaskSelectionEffectsLayer } from './GanttTaskSelectionEffectsLayer';
import type { getEffectTaskObjs } from './utils/dataLayoutUtils';

type Props<K2, D2> = {
  width: number;
  height: number;
  layoutObjs: ReturnType<typeof getEffectTaskObjs<K2, D2>>;
};

export function GanttTaskEffectsLayer<K2, D2>({
  width,
  height,
  layoutObjs: { selectedTaskObjs, hoveredTaskObj, focusedTaskObj }
}: Props<K2, D2>) {
  return (
    <TimeComponentLayersStack width={`${width}px`} height={`${height}px`}>
      <GanttTaskFocusEffectsLayer<K2> width={width} height={height} layoutObj={focusedTaskObj} />
      <GanttTaskSelectionEffectsLayer<K2>
        width={width}
        height={height}
        layoutObjs={selectedTaskObjs}
      />
      <GanttTaskHoverEffectsLayer<K2> width={width} height={height} layoutObj={hoveredTaskObj} />
    </TimeComponentLayersStack>
  );
}
